import React from 'react';
import { SectionContacts } from '../components/SectionContacts/SectionContacts';

export const Contacts = () => {
  return(
    <>
      <SectionContacts />
    </>
  );
};